import React, { memo } from 'react';
import { Grid } from 'src/components/HTKit/Grid';
import Faq from 'src/components/Elements/Faq';
import { SPEED_TEST_FAQ_DATA } from './constants';

const SpeedTestFAQ = () => (
  <Grid.Fluid>
    <Grid.Row>
      <Grid.Column sm={4} mdOffset={1} md={6} lgOffset={3} lg={6}>
        <Faq
          title="Frequently Asked Questions"
          titleStyle="h4"
          className="paddingY-large1"
          items={SPEED_TEST_FAQ_DATA}
        />
      </Grid.Column>
    </Grid.Row>
  </Grid.Fluid>
);

export default memo(SpeedTestFAQ);
